import { observer } from 'mobx-react'
import { useContext, useEffect } from 'react'
import { Header } from '@/components/Generic'
import { StoreContext } from '@store/Root.store'
import { ErrorGocardlessElavonPage } from './ErrorGocardlessElavonPage'
import { ErrorEidElavonPage } from './ErrorEidElavonPage'
import { axiosInstance } from '@/methods/axiosConfig'
import { API_URL, ONBOARDING_SERVICE_PATH } from '@/constants/apiUrl'
import { forceRedirect } from '@/methods/forceRedirect'
import { devLog } from '@/methods/devLog'
import { Illustration } from '@/components/Illustration/Illustration'
interface GenerateRedirectUrlResponse {
  redirectUrl: string
}

export const SuccessEidElavonPage = observer(() => {
  const store = useContext(StoreContext)
  const { SuccessEidPage: trans } = store.TranslationsState.translations

  const location = window.location.href
  const url = new URL(location)
  const isError = url.searchParams.get('error')
  const error = url.searchParams.get('error')

  const generateRedirectUrl = async () => {
    try {
      const { data } = await axiosInstance.get<GenerateRedirectUrlResponse>(
        `${API_URL}/${ONBOARDING_SERVICE_PATH}/get-redirect-url-on-complete`,
        {
          withCredentials: true,
        }
      )

      data?.redirectUrl && setTimeout(() => forceRedirect(data.redirectUrl), 5000)
    } catch (error) {
      devLog('Error generating url:', error)
    }
  }

  useEffect(() => {
    generateRedirectUrl()
  }, [])

  if (isError && error === 'eid_failure') return <ErrorEidElavonPage />
  if (isError && error === 'gocardless_failure') return <ErrorGocardlessElavonPage />

  return (
    <div className="page-container mobile-m-0 vertically-centered">
      <Illustration type="success" />

      <Header className="m-0-0-30">{trans.header}</Header>

      <p className="generic__paragraph-centered m-0-0-30">{trans.description}</p>
    </div>
  )
})
